<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"></hpo-filter>
          <v-divider v-if="selected.length > 0"></v-divider>
          <v-toolbar flat height="48" v-if="selected.length > 0">
            <v-btn color="primary" small @click="printSelected">
              <v-icon left small>print</v-icon> In phiếu đối soát ({{ selected.length }})
            </v-btn>
            <v-btn color="success" small class="ml-2" @click="exportSelectedExcel">
              <v-icon left small>cloud_download</v-icon> Xuất Excel ({{ selected.length }})
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" small @click="selected = []">Bỏ chọn</v-btn>
          </v-toolbar>
          <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows"
            :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100" item-key="ID"
            show-select v-model="selected" fixed-header height="calc(100vh - 300px)">
            <template v-slot:item="{ item, isSelected, select }">
              <tr :active="isSelected">
                <td @click="select(!isSelected)">
                  <v-checkbox primary hide-details :input-value="isSelected"></v-checkbox>
                </td>
                <td>{{ item.BillCode }}</td>
                <td>{{ item.CustomerName }}</td>
                <td class="text-right">{{ item.NumberOfCode | currency }}</td>
                <td class="text-right">{{ item.NumberOfPack | currency }}</td>
                <td class="text-right">{{ item.Weight | currency('', 1) }}</td>
                <td class="text-right">{{ item.Volume | currency('', 2) }}</td>
                <td class="text-right">{{ item.Deposit | currency }}</td>
                <td class="text-right">{{ item.FeeShipVND | currency }}</td>
                <td class="text-right">{{ item.DiscountAmount | currency }}</td>
                <td class="text-right">{{ item.AmountVND | currency }}</td>
                <td class="text-right">{{ item.LineAmount | currency }}</td>
                <td class="text-right">{{ item.PaidAmount | currency }}</td>
                <td class="text-right" :class="{ 'red--text': item.LineAmount - item.PaidAmount > 0 }">{{ item.LineAmount
                  - item.PaidAmount | currency }}</td>
                <td>{{ item.ExportDate | display_date }}</td>
                <td>
                  <!-- Badge: Phếu xuất còn hàng chưa về đủ -->
                  <v-chip small :color="item.IsFullyDelivered ? 'green' : 'orange darken-2'" text-color="white"
                    class="font-weight-medium">
                    <v-icon left x-small>
                      {{ item.IsFullyDelivered ? 'mdi-check-circle' : 'mdi-clock-alert-outline' }}
                    </v-icon>
                    {{ item.IsFullyDelivered ? 'Xuất đủ' : 'Chưa đủ' }}
                  </v-chip>
                </td>
                <!-- <td>{{ item.Status | display_value(bill_status_list) }}</td> -->
                <td class="text-center">
                  <v-icon medium class="mr-2" @click="openItem(item.ID)">{{ item.Status == bill_status.da_xuat ||
                    !roleAdmin ? 'visibility' : 'edit' }}</v-icon>
                  <!-- <v-icon medium class="mr-2" color="red darken-2" @click="printLabel(item)">print</v-icon> -->
                  <v-icon medium @click="deleteItem(item.ID)" :disabled="item.Status == bill_status.da_xuat"
                    v-if="roleAdmin">delete</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { currency } from "@/commons/currency";
import moment from "moment";
import _ from "lodash";
import { print_export_receipt } from '@/commons/hpod';
import { sendErrorNotice } from '@/commons/utils';

export default {
  components: {
    "hpo-filter": Filtering
  },
  data() {
    return {
      selected: [],
      pagination: { ...configs.PAGINATION },
      items_per_page: { ...configs.ITEMS_PER_PAGE },
      bill_status_list: configs.BILL_STATUS_LIST,
      bill_status: configs.BILL_STATUS,
      viewName: "bill_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      headers: [
        {
          text: this.$t('table_headers.bill_code'),
          value: "BillCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.$t('table_headers.customer_name'),
          value: "CustomerName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.$t('table_headers.number_of_code'),
          value: "NumberOfCode",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.total_pack'),
          value: "NumberOfPack",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.total_weight'),
          value: "Weight",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.total_volume'),
          value: "Volume",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.total_deposit'),
          value: "Deposit",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.fee_ship_vnd'),
          value: "FeeShipVND",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.discount_amount'),
          value: "DiscountAmount",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.amount_vnd'),
          value: "AmountVND",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.line_amount'),
          value: "LineAmount",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.paid_amount'),
          value: "PaidAmount",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.remaining_amount'),
          value: "PaidAmount",
          sortable: false,
          filterable: false,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.$t('table_headers.export_date'),
          value: "ExportDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        },
        {
          text: 'Trạng thái xuất',
          value: "IsFullyDelivered",
          filterable: true,
          values: [
            { value: 0, name: 'Chưa xuất đủ' },
            { value: 1, name: 'Xuất đủ' }
          ],
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: this.$t('table_headers.actions'),
          width: "80px",
        },
      ]
    };
  },
  watch: {
    pagination: {
      handler: function (val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
    roleAdmin() {
      this.$root.$emit('REQUEST_ROOT_OPTION', { invisibleCreateButton: !this.roleAdmin });
    }
  },
  computed: {
    ...mapState({
      items: state => state.bill.all.data,
      total_rows: state => state.bill.all.total,
      currentItem: state => state.bill.selected,
      loading: state => state.bill.loading,
      customers: state => state.customer.master.data,
    }),
    userRole() {
      return this.$store.state.authentication.user.roleid;
    },
    roleCustomer() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Customer;
    },
    roleAdmin() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Accountant || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.CustomerSupport;
    }
  },
  methods: {
    printLabel(packageCode, weight, volume) {
      var mywindow = window.open("", "PRINT");

      mywindow.document.write("<html><head><title></title>");
      mywindow.document.write(
        "<style>.row {display: flex;}.flex {flex: 1 1 auto;}.flex.lg6 {flex-basis: 50%;flex-grow: 0;max-width: 50%;}"
      );
      mywindow.document.write(
        ".flex.lg12 {flex-basis: 100%;flex-grow: 0;max-width: 100%;}.title {font-size: 24px; font-weight: bold; text-align: center; margin: 5px 0 3px 0 !important;}"
      );
      mywindow.document.write(
        ".sub-title {font-size: 16px; font-weight: bold; margin: 0 0 8px 0 !important;}.l-text {text-align: left;}.r-text {text-align: right;}.note-text {font-size: 14px; font-weight: bold; font-style: italic; text-align: center;}"
      );
      mywindow.document.write(
        "</style></head><body style='height:8cm; width:9cm; margin-left: 5px; margin-right:5px;'>"
      );
      mywindow.document.write("<div class='layout wrap'>");
      mywindow.document.write(
        `<div class='flex lg12'><p class='title'>${packageCode}</p></div>`
      );
      mywindow.document.write(
        `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Khối lượng</p></div><div class='flex lg6'><p class='sub-title r-text'>${currency(weight)} kg</p></div></div>`
      );
      mywindow.document.write(
        `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Số kiện</p></div><div class='flex lg6'><p class='sub-title r-text'>${currency(volume)}</p></div></div>`
      );
      mywindow.document.write(
        `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Ngày tạo</p></div><div class='flex lg6'><p class='sub-title r-text'>${moment(
          new Date()
        ).format("DD-MM-YYYY")}</p></div></div>`
      );
      mywindow.document.write(`<hr class='v-divider theme--light'>`);
      mywindow.document.write(
        `<div class='flex lg12'><p class='note-text'>diepanh_logistics.vn transportation & logistics</p></div>`
      );
      mywindow.document.write("</div>");
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/
      mywindow.print();
      return true;
    },
    filter_data: function () {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("bill/getList", param);
    },
    deleteItem: function (id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    newItem: function () {
      this.$store.commit("bill/setDetail", { 'ID': 0 });
      let route = this.$router.resolve({
        name: "BillDetail",
        params: { Pid: 'new', title: `Phiếu xuất mới` }
      });
      window.open(route.href, '_blank');
    },
    openItem: function (id) {
      let route = this.$router.resolve({
        name: "BillDetail",
        params: { Pid: id, title: `Chi tiết phiếu xuất (#${id})` }
      });
      window.open(route.href, '_blank');
    },
    saveItem(item) {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("bill/setDetail", {
        'data': item,
        'id': item.ID,
        'param': param
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogPackageDetail = false;
    },
    closePopup() {
      this.dialogPackageDetail = false;
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    exportData() {
      let ids = _.map(this.selected, "ID");
      var param = {
        pagination: this.pagination,
        filter: [...this.filterConditions],
        quickFilter: this.quickFilterConditions
      };
      if (ids.length > 0) {
        param.filter.push({
          column: "ID",
          value: ids,
          condition: "in",
        });
      }
      this.$store.dispatch("bill/exportList", param);
    },
    printSelected() {
      if (this.selected.length === 0) return;

      const firstUID = this.selected[0].UID;
      const sameCustomer = this.selected.every(item => item.UID === firstUID);
      if (!sameCustomer) {
        sendErrorNotice("Các phiếu được chọn phải cùng một khách hàng.");
        return;
      }

      const ids = _.map(this.selected, "ID").join(",");
      this.$store.dispatch("product/getMultiBillList", ids).then(res => {
        const products = res.data ? res.data : res;

        // Tìm thông tin khách hàng từ danh mục để fallback
        let customer = _.find(this.customers, { ID: firstUID });

        // Tạo object item tổng hợp cho trang in
        const combined = {
          UID: firstUID,
          CustomerName: this.selected[0].CustomerName,
          Username: this.selected[0].CustomerName,
          FullName: customer ? customer.FullName : '',
          PhoneNumber: customer ? customer.PhoneNumber : '',
          Address: customer ? customer.Address : '',
          ReceiveName: this.selected[0].ReceiveName || (customer ? customer.FullName : ''),
          ReceivePhone: this.selected[0].ReceivePhone || (customer ? customer.PhoneNumber : ''),
          ReceiveAddress: this.selected[0].ReceiveAddress || (customer ? customer.Address : ''),
          BillCode: _.map(this.selected, "BillCode").join(", "),
          Weight: _.sumBy(this.selected, (o) => Number(o.Weight) || 0),
          Volume: _.sumBy(this.selected, (o) => Number(o.Volume) || 0),
          NumberOfPack: _.sumBy(this.selected, (o) => Number(o.NumberOfPack) || 0),
          NumberOfCode: _.sumBy(this.selected, (o) => Number(o.NumberOfCode) || 0),
          AmountVND: _.sumBy(this.selected, (o) => Number(o.AmountVND) || 0),
          LineAmount: _.sumBy(this.selected, (o) => Number(o.LineAmount) || 0),
          PaidAmount: _.sumBy(this.selected, (o) => Number(o.PaidAmount) || 0),
          ExchangeRate: this.selected[0].ExchangeRate,
          ExportDate: moment().format('YYYY-MM-DD HH:mm')
        };

        print_export_receipt(combined, products);
      });
    },
    exportSelectedExcel() {
      if (this.selected.length === 0) return;
      const ids = _.map(this.selected, "ID").join(",");
      this.$store.dispatch("product/exportMultiBillsExcel", ids).then(() => {
        sendSuccessNotice("Đã xuất file dữ liệu thành công");
      });
    }
  },
  mounted() {
    this.$store.dispatch("customer/getCustomerList", {
      is_master: 1,
      fields: ["ID", "Username", "FullName", "PhoneNumber", "Address"]
    });
    this.$root.$emit('REQUEST_ROOT_OPTION', { invisibleCreateButton: !this.roleAdmin });
    this.$root.$on("REQUEST_CREATE_DATA", this.newItem);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("bill/removeDetail", id);
    });
    this.$root.$on("REQUEST_EXPORT_ACTION", this.exportData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.newItem);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
    this.$root.$off("REQUEST_EXPORT_ACTION");
  }
};
</script>
